import {createStore} from 'zustand/vanilla';
import type {Platform} from '../types/platforms';

export type VerificationData = {
  platform: string;
  celebrityId: number;
  profileUrl: string;
  code: string;
};

export interface VerificationState {
  confirmedPlatforms: Platform[];
  startPollingCallback: ((data: VerificationData) => void) | null;
  stopPollingCallback: ((platform?: string) => void) | null;
}

export interface VerificationActions {
  setConfirmedPlatforms: (platforms: Platform[]) => void;
  clearConfirmedPlatforms: () => void;
  startPolling: (data: VerificationData) => void;
  stopPolling: (platform?: string) => void;
  setStartPollingCallback: (callback: (data: VerificationData) => void) => void;
  setStopPollingCallback: (callback: (platform?: string) => void) => void;
}

export type VerificationStore = VerificationState & VerificationActions;

export const defaultInitState: VerificationState = {
  confirmedPlatforms: [],
  startPollingCallback: null,
  stopPollingCallback: null,
};

export const createVerificationStore = (initState: VerificationState = defaultInitState) =>
  createStore<VerificationStore>((set, get) => ({
    ...initState,

    startPolling: (data: VerificationData) => {
      const {startPollingCallback} = get();
      if (startPollingCallback) {
        startPollingCallback(data);
      }
    },
    setConfirmedPlatforms: (platforms: Platform[]) => {
      set({confirmedPlatforms: platforms});
    },
    clearConfirmedPlatforms: () => {
      set({confirmedPlatforms: []});
    },

    stopPolling: (platform?: string) => {
      const {stopPollingCallback} = get();
      if (stopPollingCallback) {
        stopPollingCallback(platform);
      }
    },

    setStartPollingCallback: (callback: (data: VerificationData) => void) => {
      set({startPollingCallback: callback});
    },

    setStopPollingCallback: (callback: (platform?: string) => void) => {
      set({stopPollingCallback: callback});
    },
  }));
